// extracted by mini-css-extract-plugin
module.exports =  {"thumbnail":"t12BP8","productImage":"U9Ncsk","productBadge":"pOAmTJ","defaultImage":"NqvveY"};